import { createFileRoute } from '@tanstack/react-router'
import { CoursesPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/corsi/')({
  loader: () => loadPageData({ data: { kind: 'courses', locale: 'it' } }),
  head: () => staticRouteHead('courses', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CoursesPage />
    </CatalogProvider>
  )
}
